
export function AvatarIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#F5F6FA"/>
      <path
        d="M26.6668 27.5V25.8333C26.6668 24.9493 26.3156 24.1014 25.6905 23.4763C25.0654 22.8512 24.2176 22.5 23.3335 22.5H16.6668C15.7828 22.5 14.9349 22.8512 14.3098 23.4763C13.6847 24.1014 13.3335 24.9493 13.3335 25.8333V27.5"
        stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M19.9998 19.1667C21.8408 19.1667 23.3332 17.6743 23.3332 15.8333C23.3332 13.9924 21.8408 12.5 19.9998 12.5C18.1589 12.5 16.6665 13.9924 16.6665 15.8333C16.6665 17.6743 18.1589 19.1667 19.9998 19.1667Z"
        stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}